/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

const apiRequest = async (method: "GET" | "POST" | "PUT" | "DELETE", endpoint: string, data: object | null, accessToken: string | null = null) => {

    const headers = new Headers();
    headers.append("Content-Type", 'application/json');
    headers.append("Accept", 'application/json');

    if (accessToken) {
        const bearer = `Bearer ${accessToken}`;
        headers.append("Authorization", bearer);
    }
    const options: RequestInit = {
        method: method,
        headers: headers,
    };

    if (data) {
        options.body = JSON.stringify(data)
    }

    return fetch(endpoint, options)
        .then((response) => {

            if (!response.ok) {
                throw response;
            }
            return response;
        })
        .then(response => {
            console.log(response);

            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") >= 0) {
                return response.json();
            }

            return;
        })
        .catch(error => {

            console.error(error);
            throw error;
        });
}

export const apiGet = async (endpoint, accessToken) => {

    return await apiRequest("GET", endpoint, null, accessToken);
}

export const apiPut = async (endpoint, data, accessToken) => {

    return await apiRequest("PUT", endpoint, data, accessToken)
}

export const apiPost = async (endpoint, data, accessToken) => {

    return await apiRequest("POST", endpoint, data, accessToken)
}

export const apiDelete = async (endpoint, accessToken) => {

    return await apiRequest("DELETE", endpoint, null, accessToken);
}